import common_en from './common_en.json'
import common_fr from './common_fr.json'
import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'
import cta_en from './cta_en.json'
import cta_fr from './cta_fr.json'
import forms_en from './forms_en.json'
import forms_fr from './forms_fr.json'
import submitClaim_en from './submitClaim_en.json'
import submitClaim_fr from './submitClaim_fr.json'

const vde_resources = {
  en: {
    ...common_en,
    ...contactInfo_en,
    ...cta_en,
    ...forms_en,
    ...submitClaim_en,
  },
  fr: {
    ...common_fr,
    ...contactInfo_fr,
    ...cta_fr,
    ...forms_fr,
    ...submitClaim_fr,
  },
}

export default vde_resources
